// src/pages/Home.js
import React, { useEffect, useState } from "react";
import blogApi from "../api/blogApi";
import { Link, useNavigate } from "react-router-dom";

const Home = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    blogApi
      .get("/api/blog/posts/")
      .then((res) => setPosts(res.data))
      .catch((err) => console.error("게시글 목록 조회 실패:", err));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[80vh]">
        <img
          src="/bg.png"
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#000000cc] to-[#00000000]" />
        <div className="relative z-10 flex items-center justify-start h-full container mx-auto px-4">
          <div className="text-white max-w-xl">
            <h1 className="text-5xl font-bold mb-6">
              IT Education <br />
              Basic & Advanced
            </h1>
            <p className="text-lg mb-6">
              Ubuntu Linux, Ansible, Docker, Kubernetes, etc.
            </p>
            <br/>
            <h1 className="text-5xl font-bold mb-6">
              System Management<br />
              
            </h1>
            <p className="text-lg mb-6">
              IT System Management Portal
            </p>
            <Link
              to="/about"
              className="inline-block bg-white text-black px-6 py-3 rounded-lg font-semibold hover:opacity-90"
            >
              자세히 보기 &gt;
            </Link>
          </div>
        </div>
      </section>

      {/* Posts Section */}
      <section className="container mx-auto px-4 py-20">
        <h2 className="text-3xl font-bold mb-12 text-center">최신 포스트</h2>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.length > 0 ? (
            posts.map((post) => (
              <li
                key={post.id}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition cursor-pointer list-none border"
                onClick={() => navigate(`/posts/${post.id}`)}
              >
                <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
                <p className="text-gray-700 mb-1">작성자: {post.author_name}</p>
                <p className="text-gray-400 text-sm">
                  {new Date(post.created_at).toLocaleString()}
                </p>
              </li>
            ))
          ) : (
            <p className="text-center col-span-3 text-gray-500">
              게시글이 없습니다.
            </p>
          )}
        </ul>
      </section>
    </div>
  );
};

export default Home;
